import { useState } from "react";
import { FAQS } from "@/mocks/reportData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">FAQ</span>
          <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
            关于爆料，你可能想问
          </h2>
          <p className="mt-3 text-[15px] leading-7 text-foreground-700">
            我们把线索人问得最多的几个问题放在这里。如果这里没有你的疑问，也可以直接通过私信与我们沟通。
          </p>
          <a
            href="#channels"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
          >
            还有疑问？去爆料入口
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </a>
        </div>

        <div className="lg:col-span-3">
          {FAQS.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-lg ring-1 ring-background-200 first:mt-0 [&+&]:mt-3"
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 bg-background-100 px-5 py-4 text-left"
                >
                  <span className="flex items-start gap-3">
                    <span className="mt-0.5 font-display text-lg font-bold text-primary-500">
                      Q{i + 1}
                    </span>
                    <span className="text-[15px] font-semibold text-foreground-900">{f.q}</span>
                  </span>
                  <i
                    className={`text-lg text-foreground-500 transition-transform ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 bg-background-50 px-5 py-4 pl-16">
                    <p className="text-[15px] leading-7 text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}